<template>
    <Frame>
        <PageHeader :title="$t('comm.message')" :hasBack="false" />
        <div>
            <div class="download-form">
                <el-table :data="tableData" style="width: 100%" :height="tableHeight" v-loading="tableLoading">
                    <el-table-column prop="name" :label="$t('BulletinCenter.maintitle')">
                        <template slot-scope="scope">
                            <el-link :underline="false" @click="viewDetail(scope.$index, scope.row)">
                                {{ scope.row.name }}
                            </el-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="PushTime" :label="$t('BulletinCenter.sendtime')">
                    </el-table-column>
                    <el-table-column prop="option" :label="$t('HelpCenter.operation')" width="100">
                        <template slot-scope="scope">
                            <el-link :underline="false" @click="viewDetail(scope.$index, scope.row)" type="primary">
                                {{ $t('button.check') }}
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination ref="pagination" style="padding-left:50%;width:50%;" @current-change="handleCurrentChange"
                    layout="total,prev,pager,next,jumper" :pager-count="5" :current-page.sync="currentPage"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </Frame>
</template>

<script>
export default {
    name: "HelpCenter",
    data() {
        return {
            tableData: [],
            value: '',
            searchinput: '',
            tableLoading: false,
            totalCount: 0,
            currentPage: 3,
            pageindex: 0,
            pagesize: 10,
            tableHeight: window.innerHeight - 247,
        }
    },
    mounted() {
        let that = this
        window.onresize = () => {
            if (that.resizeFlag) {
                clearTimeout(that.resizeFlag);
            }
            that.resizeFlag = setTimeout(() => {
                that.tableHeight = window.innerHeight - 247
                that.resizeFlag = null;
            }, 100);
        }
        if(sessionStorage.getItem("informationPage")){
            debugger
            var currentpage = parseInt(sessionStorage.getItem("informationPage"));
            this.getinformation(currentpage);
            sessionStorage.removeItem("informationPage");
        }else{
            this.getinformation(0);
        }
    },
    methods: {
        getinformation(pageindex) {
            this.tableLoading = true;
            this.axiosInvoke("/SupplierComm/Handler/BulletinHandler.ashx?",
                {
                    action: "getallinformation",
                    loadMore:true, // 消息列表需要全部查询，该属性为true
                    pageindex,
                    pagesize: this.pagesize
                }, (res) => {
                    let data = eval(res.data);
                    console.log(data);
                    this.totalCount = data[0].totalcount;
                    this.currentPage = pageindex+1;
                    data.forEach(v => {
                        v.BillNo=v.FromBillNo;
                        switch (v.Oppo) {
                            case 0://生效
                                switch(v.FromSourceTag){
                                    case 2601:
                                        v.name = this.$t("Default.haveaneworder").replace("{0}", v.FromBillNo);
                                        break;
                                    case 20021:
                                        v.name = this.$t("Default.haveqmabnqlyorder").replace("{0}", v.FromBillNo);
                                        break;
                                }
                            break;
                            case 1://变更 
                                switch(v.FromSourceTag){
                                    case 2601:
                                        v.name = this.$t("Default.haveanewchange").replace("{0}", v.FromBillNo);
                                    break;
                                }
                            break;
                            case 2://结案
                                switch(v.FromSourceTag){
                                    case 2601:
                                        v.name = this.$t("Default.orderendcase").replace("{0}", v.FromBillNo);
                                        break;
                                }
                                break;
                            case 3://图纸变更
                                v.name = this.$t('comm.order') + "[" + v.FromBillNo + "]" + this.$t('Default.printhavenew');
                                break;
                            case 4://企业自行变更交期
                                v.pageType='purTrackMatRecord';
                                v.name = this.$t("Default.ConfirmState0").replace("{0}", v.FromBillNo);
                                v.ConfirmState=0;//交期变更处理状态：未变更
                            break;
                            case 5://同意交期变更
                                v.pageType='purTrackMat';
                                v.name = this.$t("Default.ConfirmState3").replace("{0}", v.FromBillNo);
                                v.ConfirmState=3;//交期变更处理状态：已变更
                            break;
                            case 6://不同意交期变更
                                v.pageType='purTrackMat';
                                v.name = this.$t("Default.ConfirmState2").replace("{0}", v.FromBillNo);
                                v.ConfirmState=2;//交期变更处理状态：不同意变更
                                break;
                            case 7://询价需求发布单发布
                                v.name = this.$t("Default.haveQuotePublish").replace("{0}", v.FromBillNo);
                            break;
                            case 8://询价需求发布单撤销
                                v.name = this.$t("Default.haveQuoteWithDraw").replace("{0}", v.FromBillNo);
                            break;
                            case 9://询价需求发布单重新发布
                                v.name = this.$t("Default.haveQuoteRePublish").replace("{0}", v.FromBillNo);
                            break;
                            case 10://供应商报价选中
                                v.name = this.$t("Default.QuotePitchOn").replace("{0}", v.FromBillNo);
                            break;
                            case 11://供应商报价落选
                                v.name = this.$t("Default.FailQuotePitchOn").replace("{0}", v.FromBillNo);
                            break;
                        }
                    });
                    data.shift();
                    this.tableData = data;
                    this.tableLoading = false;
                }
            )
        },
        handleCurrentChange(val) {
            debugger
            this.currentPage = val;
            this.pageindex = val - 1;
            this.getinformation(val - 1);
        },
        viewDetail(index, row) {
            //设置已读
            if(row.PushId){
                if(row.Oppo==3){
                    this.axiosInvoke("/SupplierComm/Handler/BulletinHandler.ashx",{
                    action: "readpushbyno",
                    billNo: row.BillNo,
                    fromSourceTag: row.FromSourceTag,
                    pushid: row.PushId
                    }, (res) => {
                        
                    });  
                }else{
                    this.axiosInvoke("/SupplierComm/Handler/BulletinHandler.ashx",{
                    action: "readpushrecord",
                    pushid: row.PushId
                    }, (res) => {
                        
                    });  
                } 
            }  
            if(typeof(row.pageType) != 'undefined' && row.pageType == 'purTrackMat'){
                this.$router.push({
                path: "/Home/ReplyDeliveryTime", // 跳转回复交期
                query: {
                    billNoList: row.BillNo, // 单号列表，从消息区传值
                    confirmState:row.ConfirmState // 交期变更处理状况
                }
                });
            }
            else if(typeof(row.pageType) != 'undefined' && row.pageType == 'purTrackMatRecord'){
                this.$router.push({
                path: "/Home/OrderDetailSearch", // 跳转订单详情查询
                query: {
                    billNoList: row.BillNo, // 单号列表，从消息区传值
                    confirmState:row.ConfirmState // 交期变更处理状况
                }
                });
            }
          else if(row.FromSourceTag == 2601){
                        this.$router.push({
                        path: "/Home/OrderDetail",
                        query: {
                        DelBillNo: row.BillNo,
                    }
                    })
                    }
          else if(row.FromSourceTag == 20021){
            this.$router.push({
                path: "/Home/QmAbnQlyOrderDetail",
                  query: {
                    BillNo: row.BillNo,
                  }
                })
            }
            else if(row.FromSourceTag == 2076){
            this.$router.push({
                path: "/Home/QuotationDetail",
                  query: {
                    BillNo: row.BillNo,
                  }
                })
            }
        }
    }
}
</script>

<style scoped>
.el-container /deep/.el-main {
    padding: 0;
    margin: 0;
}

.download-form {
    width: 95%;
    padding: 25px 2.5%;
}

.pagination {
    width: 100%;
}
</style>